
          import defu from 'defu'
          import { plugin, defaultConfig, createInput } from '@formkit/vue'
          import { nl } from '@formkit/i18n'

          // Todo:
          // - map against existing translations available in formkit

          import nlCustom from '~~layers/i18n/formkit/nl.ts'

          import { FormKitMinmaxrange, FormKitRating, FormKitToggle } from '#components'

          import formkitConf from '~~layers/formkit.config.ts'

          const formkitConfig = formkitConf() || {}

          export default defineNuxtPlugin((nuxtApp) => {

            nuxtApp.vueApp.use(
              plugin,
              defaultConfig(
                defu(formkitConfig, {
                  locale: 'nl',
                  locales: {
                    'nl': defu(nlCustom, nl)
                  },
                  inputs: {
                    minmaxrange: createInput(FormKitMinmaxrange), rating: createInput(FormKitRating), toggle: createInput(FormKitToggle),
                  },
                })
              )
            )
          })
        